function passwordValidator(value = '') {
  let isValid

  const { path, createError } = this

  isValid = value.match(/^(?=.*\d)(?=.*[A-Z])(?=.*[a-z]).{8,}$/)

  return (
    isValid ||
    createError({
      path,
      message: 'common::validation_messages.incorrect_password_format',
    })
  )
}

export default passwordValidator
